import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import React from 'react';
import { useTranslation } from 'shared/translations';
import ThemedImage from 'shared/components/Themed/Image';
import happyEmptyStateImage from 'public/assets/images/check.png';
export default function HappyEmptyState() {
  const $ = _c(19);
  const {
    t
  } = useTranslation("recommendation");
  let t0;
  if ($[0] !== t) {
    t0 = t("happyEmptyState.altText");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maxWidth: "100%",
      height: "auto"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Grid marginTop="16px" display="flex" alignItems="center" justifyContent="center" width="100%"><StyledResponsiveImage src={happyEmptyStateImage} alt={t0} width={224} height={99} style={t1} /></Grid>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("happyEmptyState.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Grid item={true} xs={12} textAlign="center"><Typography variant="h4">{t3}</Typography></Grid>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("happyEmptyState.description");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Grid item={true} width="272px" textAlign="center"><Typography variant="body3">{t5}</Typography></Grid>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <Grid container={true} gap="16px" justifyContent="center">{t4}{t6}</Grid>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t7) {
    t8 = <Grid container={true} direction="column" alignItems="center" justifyContent="center" gap="24px">{t2}{t7}</Grid>;
    $[16] = t2;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
const StyledResponsiveImage = styled(ThemedImage)(() => ({
  maxWidth: '100%',
  height: 'auto'
}));